import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useChecklistTemplatesQuery = () =>
  useTypedQuery({
    queryKey: ChecklistSettingsDashboardQueryKeys.checklistTemplates,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.checklist_templates,
    enabled: useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.ChecklistTemplates)
  });
